import $ from 'jquery';
import whatInput from 'what-input';
import { removeFocusTrap, setFocusTrap } from '../utils/focusTrap';

const duration = 200;
const navSearch = document.querySelector('.navbar__search');
const toggle = navSearch.dataset.searchToggle;
const toggler = document.getElementById(toggle);
const closeSearchBtn = toggler.querySelector('.js-close-search-form');

const openSearch = () => {
  setFocusTrap(toggler);

  const input = toggler.querySelector('input');
  $(toggler).slideDown(duration);
  input.focus();
  toggler.classList.add('search-form-top--open');
}

const closeSearch = () => {
  $(toggler).slideUp(duration);
  removeFocusTrap(toggler);
  toggler.classList.remove('search-form-top--open');

  if (whatInput.ask('intent') === 'keyboard') {
    navSearch.focus();
  }
}


navSearch.addEventListener('click', () => {
  openSearch();
});

closeSearchBtn.addEventListener('click', () => {
  closeSearch();
});

// Close search on esc for accessibility
window.addEventListener('keyup', (e) => {
  if ((e.keyCode === 27 || ('key' in e && e.key === 'Escape')) && toggler.classList.contains('search-form-top--open')) {
    closeSearch();
  }
})
